<ng-container *ngFor="let item of navItemsArray">
  <ng-container [ngSwitch]="helper.itemType(item)">
    <c-sidebar-nav-group
      *ngSwitchCase="'group'"
      [item]="item"
      [ngClass]="item | cSidebarNavItemClass"
      routerLinkActive="show"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{exact: true}"
    >
    </c-sidebar-nav-group>
    <c-sidebar-nav-divider
      *ngSwitchCase="'divider'"
      [item]="item"
      [ngClass]="item | cSidebarNavItemClass"
      [cHtmlAttr]="item.attributes ?? {}">
    </c-sidebar-nav-divider>
    <c-sidebar-nav-title
      *ngSwitchCase="'title'"
      [item]="item"
      [ngClass]="item | cSidebarNavItemClass"
      [cHtmlAttr]="item.attributes ?? {}">
    </c-sidebar-nav-title>
    <c-sidebar-nav-label
      *ngSwitchCase="'label'"
      [item]="item"
      [ngClass]="item | cSidebarNavItemClass">
    </c-sidebar-nav-label>
    <ng-container
      *ngSwitchCase="'empty'">
    </ng-container>
    <c-sidebar-nav-link
      *ngSwitchDefault
      [item]="item"
      [ngClass]="item | cSidebarNavItemClass"
      (linkClick)="hideMobile()"
    >
    </c-sidebar-nav-link>
  </ng-container>
</ng-container>
<ng-content></ng-content>
